<template>
  <div>
    <a-card max-width="50rem" class="system-feedback-center">
      <span slot="header" v-text="title" />
      <div slot="body" v-text="message" />
      <template slot="footer">
        <button
          v-if="optionalButtonText.length > 0"
          class="btn btn-pf-secondary"
          @click="$emit('optional-button-action')"
          v-text="optionalButtonText"
        />
        <button
          class="btn btn-pf-primary"
          @click="$router.push(primaryButtonRoute)"
          v-text="primaryButtonText"
        />
      </template>
    </a-card>
  </div>
</template>

<script>
import Card from "+/components/card/Card";

export default {
  components: {
    "a-card": Card
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t("Components.SystemFeedBack.Title");
      }
    },
    message: {
      type: String,
      default() {
        return this.$t("Components.SystemFeedBack.Message");
      }
    },
    primaryButtonText: {
      type: String,
      default() {
        return this.$t("Components.SystemFeedBack.PrimaryButtonText");
      }
    },
    primaryButtonRoute: {
      type: String,
      default: "/"
    },
    optionalButtonText: {
      type: String,
      default() {
        return "";
      }
    }
  }
};
</script>
